import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, InputAdornment, SxProps, Typography } from '@mui/material';
import { Ref } from 'react';
import { useNavigate } from 'react-router-dom';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import InputField from '../../elements/InputField';
const styles: IStyles = {
  root: {
    // mt: { xs: pxToRem(50), md: pxTovW(60) },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(20) },
    width: '100%',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  helperText: {
    bgcolor: '#FFDFDF',
    color: 'error.main',
    padding: { xs: pxToRem(10), md: `${pxTovW(12)} ${pxTovW(30)}` },
  },
  helperText2: {
    height: { xs: pxToRem(15), md: pxTovW(30) },
  },
};
interface InputContainerProps {
  topLabel: string;
  type?: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  helperText?: string;
  nonEditable?: boolean;
  helperTextvariant: 'success' | 'error';
  editFunction?: () => void;
  onEnter?: () => void;
  InputFieldRef?: Ref<unknown>;
  rootSx?: SxProps;
}
export const InputFieldContainer = ({
  topLabel,
  type,
  value,
  onChange,
  helperText,
  nonEditable,
  helperTextvariant,
  editFunction,
  onEnter,
  InputFieldRef,
  rootSx,
}: InputContainerProps) => {
  let rootStyles = { ...styles.root };
  if (rootSx) rootStyles = { ...rootStyles, ...rootSx };
  const navigate = useNavigate();
  const handleEdit = () => {
    if (editFunction) {
      editFunction();
    } else {
      return;
    }
  };
  return (
    <Box sx={rootStyles}>
      <Typography variant="cardText">{topLabel}</Typography>
      <Box sx={styles.inputContainer}>
        <InputField
          variant="outlined"
          fullWidth
          boldtext
          nonCircular
          type={type ? type : 'text'}
          ref={InputFieldRef}
          value={value}
          onChange={onChange}
          onKeyDown={(e) => e.code === 'Enter' && onEnter && onEnter()}
          sx={{
            bgcolor: nonEditable ? '#EEEEEE' : 'neutral.lightBlue',
            border: 'none',
            // mb: nonEditable ? '20px' : '0px',
          }}
          disabled={nonEditable ? true : false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" onClick={handleEdit}>
                {nonEditable && editFunction && (
                  <IconWrapper
                    name="edit2"
                    type="png"
                    parentFolder="icons"
                    customSx={{
                      height: { xs: pxToRem(29), md: pxTovW(47) },
                      width: { xs: pxToRem(30), md: pxTovW(48) },
                      cursor: 'pointer',
                    }}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
        {helperText ? (
          <Typography
            variant="h4"
            sx={{
              bgcolor: variantMapping[helperTextvariant].bgColor,
              color: variantMapping[helperTextvariant].textColor,
              padding: { xs: pxToRem(10), md: `${pxTovW(12)} ${pxTovW(30)}` },
              mb: { xs: pxToRem(24), md: pxTovW(30) },
            }}
          >
            {helperText}*
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

const EditIcon = () => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        padding: { md: pxTovW(12.5) },
        borderRadius: { xs: pxToRem(4), md: pxTovW(8) },
      }}
    >
      <EditOutlinedIcon fontSize="medium" color="secondary" />
    </Box>
  );
};
const variantMapping = {
  success: {
    bgColor: '#F1FFF7',
    textColor: '#0AA34F',
    border: '2px solid #0AA34F',
  },
  error: {
    bgColor: '#FFEAEA',
    textColor: '#F54040',
    border: '2px solid #F54040',
  },
};
